// Environment configuration
const env = {
  OPENAI_API_KEY: process.env.REACT_APP_OPENAI_API_KEY || process.env.VITE_OPENAI_API_KEY,
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
};

// Validate required environment variables
const validateEnv = () => {
  const required = {
    OPENAI_API_KEY: env.OPENAI_API_KEY,
  };

  const missing = Object.entries(required)
    .filter(([_, value]) => !value)
    .map(([key]) => key);

  if (missing.length > 0) {
    console.error('Missing required environment variables:', missing.join(', '));
    if (env.isDevelopment) {
      console.error(`
Please create a .env file in the project root with the following content:

REACT_APP_OPENAI_API_KEY=your_openai_api_key_here

Get your API key from: https://platform.openai.com/account/api-keys
      `);
    }
    return false;
  }

  return true;
};

export { env, validateEnv };
